/**
 * Extracts filename from Content-Disposition header
 * Supports formats: filename="name.ext", filename=name.ext, filename*=UTF-8''name.ext
 */
export function getFilenameFromContentDisposition(contentDisposition?: string): string | null {
    if (!contentDisposition) {
        return null;
    }

    const filenameStarMatch = contentDisposition.match(/filename\*=(?:UTF-8'')?([^;\n]+)/i);
    if (filenameStarMatch?.[1]) {
        return decodeURIComponent(filenameStarMatch[1].replace(/['"]/g, ''));
    }

    const filenameMatch = contentDisposition.match(/filename[^;=\n]*=\s*((['"]).*?\2|[^;\n]*)/i);
    if (filenameMatch?.[1]) {
        return filenameMatch[1].replace(/['"]/g, '').trim();
    }

    return null;
}

/**
 * Downloads a Blob as a file with the specified filename
 */
export function downloadBlobAsFile(blob: Blob, filename: string): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.target = '_blank';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
}

/**
 * Downloads a file from a URL by creating a temporary anchor element
 */
export function downloadFileFromUrl(url: string, filename?: string): void {
    const link = document.createElement('a');
    link.href = url;
    if (filename) {
        link.download = filename;
    }
    link.target = '_blank';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

/**
 * Detects if running on Chrome iOS (CriOS)
 */
function getIsChromeIos(): boolean {
    return window.navigator.userAgent.includes('CriOS');
}

/**
 * Downloads a Blob with special handling for Chrome iOS
 */
export function downloadBlobWithChromeIosSupport(blob: Blob, filename: string): void {
    if (getIsChromeIos()) {
        const reader = new FileReader();
        reader.onload = () => {
            if (typeof reader.result === 'string') {
                window.location.href = reader.result;
            }
        };
        reader.readAsDataURL(blob);
        return;
    }

    downloadBlobAsFile(blob, filename);
}
